module.exports = __webpack_public_path__ + "static/media/asian-pork-dumpling.e779de10.png";